<template>
  <div class="event-details-box">
    <div class="event-registration-box">
      <payment-summary :formTitle="eventConfig['names-label-your-total']" priceTitle="" :products="products" :donationPrice="donation"/>
    </div>
    <div class="event-form-wrap event-box-shadow">
      <el-form
        v-if="initForm"
        label-position="top"
        label-width="100px"
        ref="dynamicForm"
        :model="dynamicForm"
        v-loading="processing"
        element-loading-text="Validate transaction..."
      >
        <div v-for="item in tickets" :key="item.code" class="mb-4">
          <div class="event-rg-form" v-for="(participant, index) in dynamicForm[item.code]" :key="item.code + index">
            <h6 v-if="index === 0">
              <template v-if="item.type === 'individual'">{{ groupTitle(item.code) }}</template>
              <template v-else>{{ ticketName(item.code) }}</template>
            </h6>
            <div class="d-flex align-items-center event-step-active">
              <span class="event-step-count">{{ index + 1 }}</span>
              <span class="event-step-text" v-if="item.type === 'individual'">{{ ticketName(item.code) }}</span>
              <span class="event-step-text" v-else>Table Owner</span>
            </div>
            <div class="form-row">
              <div class="col-md-12 mt-2 mb-3 event-table-captain-text" v-if="item.type === 'table'">{{ eventConfig['validation-contact-form']['event-table-captain'] }}</div>
              <div class="col-md-12 mt-2" v-if="donationDetail && !eventConfig['registration-locked']">
                <label class="event-checkbox-style">
                  <input type="checkbox" :checked="participant.isDonationDetailUsed" @input="handleDonationDetailChecked(item.code, index)">
                  <span class="event-cstm-checkbox"></span>
                  Use {{ donationDetail.first_name }}&nbsp;{{ donationDetail.last_name }} details
                </label>
              </div>
              <div class="col-md-2 mt-2">
                <el-form-item label="Prefix" :prop="item.code + '.' + index + '.prefix'" :rules="fieldRule('prefix')">
                  <el-select v-model="participant.prefix" placeholder="Prefix" :disabled="participant.isNullprefix && (participant.isDonationDetailUsed || eventConfig['registration-locked'])">
                    <el-option label="Select" value=""></el-option>
                    <el-option v-for="item in eventConfig['prefix-list'].items" :key="item.prefix" :value="item.prefix" :label="item.prefix"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="col-md-10 mt-2">
                <div class="form-row">
                  <div class="col-md-4">
                    <el-form-item label="First name" :prop="item.code + '.' + index + '.firstName'" :rules="fieldRule('firstName')" >
                      <el-input v-model="participant.firstName" placeholder="First name" v-on:blur="onParticipantChange(item.code, index)" :disabled="participant.isNullfirstName && (participant.isDonationDetailUsed || eventConfig['registration-locked'])"></el-input>
                    </el-form-item>
                  </div>
                  <div class="col-md-4">
                    

                    <el-form-item label="Last name" :prop="item.code + '.' + index + '.lastName'" :rules="fieldRule('lastName')" >
                      <el-input v-model="participant.lastName" placeholder="Last name" :disabled="participant.isNulllastName && (participant.isDonationDetailUsed || eventConfig['registration-locked'])"></el-input>
                    </el-form-item>
                  </div>
                  <div class="col-md-4">
                    

                    <el-form-item label="Post Nominals" :prop="item.code + '.' + index + '.postNominals'">
                      <el-input v-model="participant.postNominals" placeholder="eg: AO, BM"></el-input>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mt-4">
                <el-form-item label="Informal Name" :prop="item.code + '.' + index + '.informalName'" :rules="fieldRule('informalName')">
                  <el-input v-model="participant.informalName" placeholder="eg: Meggie" :disabled="participant.isNullinformalName && (participant.isDonationDetailUsed || eventConfig['registration-locked'])"></el-input>
                </el-form-item>
              </div>
              
              <div class="col-md-6 mt-4">
                <el-form-item label="Company Title" :prop="item.code + '.' + index + '.companyTitle'" :rules="fieldRule('companyTitle')">
                  <el-input v-model="participant.companyTitle" placeholder="eg: Human Resource Manager"></el-input>
                </el-form-item>
              </div>
              <div class="col-md-12 mt-4">
                <el-form-item label="Company Name" :prop="item.code + '.' + index + '.companyName'">
                  <el-input v-model="participant.companyName" placeholder="Company name"></el-input>
                </el-form-item>
              </div>
              <div class="col-md-6 mt-4">
                <el-form-item label="Email address" :prop="item.code + '.' + index + '.email'" :rules="fieldRule('email')">
                  <el-input type="email" v-model="participant.email" placeholder="eg: name@email.com.au" prefix-icon="el-icon-message" :disabled="participant.isNullemail && (participant.isDonationDetailUsed || eventConfig['registration-locked'])"></el-input>
                </el-form-item>
              </div>
              <div class="col-md-6 mt-4">
                <el-form-item label="Mobile number" :prop="item.code + '.' + index + '.mobile'" :rules="fieldRule('mobile')">
                  <el-input v-model="participant.mobile" placeholder="eg: 0412 345 678" prefix-icon="el-icon-phone" :disabled="participant.isNullmobile && (participant.isDonationDetailUsed || eventConfig['registration-locked'])"></el-input>
                </el-form-item>
              </div>
              <div class="col-md-12 mt-4" v-if="eventDetail['RegistrationQuestion'] !== null">
                <el-form-item :label="eventDetail['RegistrationQuestion']" :prop="item.code + '.' + index + '.registrationComment'">
                  <el-input v-model="participant.registrationComment" :placeholder="eventDetail['RegistrationQuestion']"></el-input>
                </el-form-item>
              </div>
              <template v-if="item.type === 'individual'">
                <template v-if="eventDetail.CollectDiet">
                  <div class="col-md-6 mt-4">
                    <el-form-item label="Dietary requirements" :prop="item.code + '.' + index + '.dietaryRequirements'">
                      <el-select v-model="participant.dietaryRequirements" placeholder="Dietary requirements" class="w-100" v-on:change="onParticipantChange(item.code, index)">
                        <el-option label="Select" value=""></el-option>
                        <el-option v-for="item in eventConfig['diet-options'].items" :key="item['diet-option']" :value="item['diet-option']" :label="item['diet-option']"></el-option>

  <!--                      <el-option value="OTH" label="OTH"></el-option>-->

                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="col-md-6 mt-4" v-if="participant.dietaryRequirements.toLowerCase() === 'other'">
                    <el-form-item label="Dietary Other" :prop="item.code + '.' + index + '.dietaryOther'" :rules="fieldRule('dietaryOther')">
                      <el-input v-model="participant.dietaryOther" placeholder="eg: Dietary Other"></el-input>
                    </el-form-item>
                  </div>
                </template>


                <div v-if="eventDetail.CollectAccessibility" class="col-md-6 mt-4">
                  <el-form-item label="Accessibility requirements" :prop="item.code + '.' + index + '.accessibilityRequirements'">
                    <el-select v-model="participant.accessibilityRequirements" placeholder="Accessibility requirements" class="w-100" v-on:change="onParticipantChange(item.code, index)">
                      <el-option label="Select" value=""></el-option>
                      <el-option v-for="item in eventConfig['access-options'].items" :key="item['access-option']" :value="item['access-option']" :label="item['access-option']"></el-option>
                    </el-select>
                  </el-form-item>
                </div>

              </template>
            </div>
            <hr class="my-4" v-if="index < (dynamicForm[item.code].length - 1)" />
          </div>
        </div>

        <hr />
        <div class="col-md-12 mt-2 event-rg-form" v-if="eventDetail && eventDetail['DonationFunction'] !== null">
          <el-form-item prop="useDonation">
            <el-checkbox v-model="dynamicForm.useDonation">
              <span class="event-cstm-checkbox"></span> {{ eventConfig['names-label-donation'] }}
            </el-checkbox>
          </el-form-item>
          <template v-if="dynamicForm.useDonation">
            <p>Select amount</p>
            <el-radio-group
              @change="onSelectAmount"
              size="medium"
              v-model="dynamicForm.donation"
            >
              <el-radio
                v-for="(gift, i) in getAmountLists"
                :label="typeof gift === 'object' ? gift['gift-amount'] : gift"
                :key="i"
                border
              >
              {{ typeof gift === 'object' ? '$' + gift['gift-amount'] : '$' + gift }}
              </el-radio>
            </el-radio-group>

            <p>Enter your own amount</p>
            <el-form-item class="custom-input">
              <img class="dollar-sign" src="../../assets/icons/dollar.svg" alt="" />
              <el-input
                v-model.number="dynamicForm.customDonation"
                @input="validateCustomAmount"
                placeholder="Enter amount"
              />
            </el-form-item>
            <el-alert
              :title="amountError.message"
              type="error"
              show-icon
              v-show="amountError.show"
              @close="amountError = false"
            />
          </template>
        </div>
      </el-form>
      <hr />
      <!-- /.event-rg-form -->
      <div class="mb-3 px-4" v-if="!valid">
        <el-alert v-if="eventConfig && eventConfig['validation-event-tickets']" :title="eventConfig['validation-event-tickets']['validation-event-general']" type="error" show-icon></el-alert>
      </div>
      
      <div class="mb-3 px-4" v-if="isOneClickRequired">
        <el-alert v-if="eventConfig && eventConfig['oneclick-required']" title="This event is invite only and you must include yourself as part of registration." type="error" show-icon></el-alert>
      </div>

      <div class="mb-3 px-4" v-if="freeEvent.show">
        <el-alert :title="freeEvent.message" type="error" show-icon></el-alert>
      </div>
      
      <div class="mb-3 px-4" v-if="isDuplicateParticipant">
        <el-alert title="You cannot register the same person more than once" type="error" show-icon></el-alert>
      </div>
      <div class="event-btn d-flex flex-wrap event-rg-form">
        <button @click="onBackClick" class="btn btn-secondary">Back</button>
        <button @click="onNextClick" class="btn btn-primary">Next <i class="far fa-arrow-right ml-2"></i></button>
      </div>
    </div>
  </div><!-- /.event-else-wrapper -->
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import PaymentSummary from '../_FormElements/PaymentSummary.vue';

export default {
  components: {
    PaymentSummary
  },
  props: {
    tickets: { type: Array, required: true },
    eventDetail: { type: Object, required: true },
    eventConfig: { type: Object, required: true },
    donationConfig: Object,
    donationDetail: {
      type: Object,
      default: () => null
    },
    participants: [Array, Object]
  },
  data: function () {
    return {
      dynamicForm: {
        useDonation: false,
        donation: 0,
        customDonation: 0
      },
      formRules: {
        firstName: { required: true, message: 'First name can not be null', trigger: 'blur' },
        lastName: { required: true, message: 'Last name can not be null', trigger: 'blur' },
        dietaryOther: { required: true, message: 'Dietary other can not be null', trigger: 'blur' },
        accessibilityOther: { required: true, message: 'Accessibility other can not be null', trigger: 'blur' },
      },
      amountError: { show: false, message: "" },
      freeEvent: { show: false, message: "" },
      addDonation: false,
      valid: true,
      isDuplicateParticipant: false,
      isOneClickRequired: false,
      initForm: false,
      processing: false
    }
  },
  created: function() {
    this.initParticipants().then(() => {
      this.formRules = {
        ...this.formRules,
        email: [
          { required: true, message: 'Email address can not be null', trigger: 'blur' },
          { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
        ],
        mobile: { required: true, message: 'Mobile number can not be null', trigger: 'blur' },
      };

      this.initForm = true;
    });
  },
  watch: {
    "dynamicForm.customDonation": function() {
      if (this.dynamicForm.customDonation > 0) {
        this.dynamicForm.donation = 0;
      }
    },
    "dynamicForm.donation": function() {
      this.dynamicForm.customDonation = 0;
    },
    "dynamicForm.useDonation": function() {
      if (!this.dynamicForm.useDonation) {
        this.dynamicForm.donation = 0;
        this.dynamicForm.customDonation = 0;
      }
    },
  },
  computed: {
    products: function () {
      const items = this.tickets.map(ticket => ({
        'product-code': ticket.code,
        'product-description': ticket.name,
        'total-price': ticket.total
      }));

      return items;
    },
    fieldRule: function () {
      return (type) => {
        if (type in this.formRules) {
          return this.formRules[type];
        }
        return;
      }
    },
    getAmountLists: function () {
      if (this.donationConfig['gift-array']) {
        return this.donationConfig['gift-array'];
      }

      return [45, 99, 250, 400];
    },
    donation: function(){
      return Number(this.dynamicForm.customDonation) + Number(this.dynamicForm.donation);
    },

    calcTotal : function(){
      const price = []
      this.products.forEach(product => {
        price.push(product['total-price'])
      })


      const total = price.reduce((a,b) => {
        if(a !== undefined && b !== undefined) {
          return parseInt(a) + parseInt(b)
        }
      }, 0)
      
      return total + this.donation
    },
    /*
    showOneClickError() {
    }
    */
  },
  methods: {
    ...mapMutations('eventRegistration', ['setStatus', 'setDuplicateParticipant', "setParticipants"]),
    ...mapActions('eventRegistration', ['checkDuplicateRegister']),
    ...mapActions('eventRegistration', ['sendPayment']),

    initParticipants: async function () {
      const codeParticipant = {};
      this.tickets.forEach(ticket => {
        codeParticipant[ticket.code] = [];
        const totalParticipant = (ticket.type === 'individual') ? Number.parseInt(ticket.value) : 1;
        for (let i = 0; i < totalParticipant; i++) {
          let initData = {
            prefix: null,
            firstName: null,
            lastName: null,
            postNominals: null,
            informalName: "",
            companyTitle: null,
            companyName: null,
            email: null,
            mobile: null,
            Jwt: null,
            isDonationDetailUsed: false,
            dietaryRequirements: "",
            dietaryOther: null,
            accessibilityRequirements: "",
            accessibilityOther: null,
            registrationComment: null,
            isNullprefix: true,
            isNullfirstName: true,
            isNulllastName: true,
            isNullinformalName: true,
            isNullemail: true,
            isNullmobile: true,
          };

          if(this.eventConfig['registration-locked'])
          {
              let { first_name, last_name, mobile, prefix, email, informal_name, company_name, company_title, diet, diet_other, access, access_other, jwt } = this.donationDetail
                initData.prefix = prefix;
                initData.firstName = first_name;
                initData.lastName = last_name;
                initData.informalName = informal_name;
                initData.companyTitle = company_title;
                initData.companyName = company_name;
                initData.email = email;
                initData.mobile = mobile;
                initData.Jwt = jwt;

                initData.isNullprefix = initData.prefix && initData.prefix != '' ? true : false;
                initData.isNullfirstName = initData.firstName && initData.firstName != '' ? true : false;
                initData.isNulllastName = initData.lastName && initData.lastName != '' ? true : false;
                initData.isNullinformalName = initData.informalName && initData.informalName != '' ? true : false;
                initData.isNullemail = initData.email && initData.email != '' ? true : false;
                initData.isNullmobile = initData.mobile && initData.mobile != '' ? true : false;



                if(diet === "OTH") {
                  initData.dietaryRequirements = diet_other;
                } else {
                  initData.dietaryRequirements = diet;
                }
                if(access === "OTH") {
                  initData.accessibilityRequirements = access_other;
                } else {
                  initData.accessibilityRequirements = access;
                }
          }

          if (this.participants?.[ticket.code]?.[i]) {
            initData = {
              ...initData,
              ...this.participants[ticket.code][i]
            }
          }
          codeParticipant[ticket.code].push(initData);
        }
      });

      this.dynamicForm = {
        ...this.dynamicForm,
        ...this.participants,
        ...codeParticipant
      };
    },
    onBackClick: function () {
      this.$emit('next-step', { step: 1 });
    },
    onNextClick: function () {
      this.isDuplicateParticipant = false;
      this.isOneClickRequired = false;
      if (!this.amountError.show && !this.processing) {
        this.processing = true;
        this.$refs['dynamicForm'].validate(async (valid) => {
          this.valid = valid;
          if (valid) {

            let participants = [];

            this.tickets.forEach(ticket => {
              this.dynamicForm[ticket.code].forEach(participant => {
                participants.push({
                    FirstName: participant.firstName,
                    LastName: participant.lastName,
                    Mobile: participant.mobile,
                    Email: participant.email,
                    isDonationDetailUsed: participant.isDonationDetailUsed
                })
              });
            });

            // set oneClick required in the case that it is not an invite only. Check donation detail (eventUser) exists
            if(this.eventConfig['oneclick-required'] && this.donationDetail && !this.eventConfig['registration-locked'])
            {
              let countIsDonationUsed = participants.filter(participant => {
                return participant.isDonationDetailUsed
              })
              if(countIsDonationUsed.length <= 0)
              {
                this.isOneClickRequired = true;
                this.processing = false;
                return;
              }
            }

            if(participants.length > 1)
            {
              participants.forEach((participant, index) => {

                  let mobileParticipant = { FirstName: participant.FirstName, LastName: participant.LastName, Mobile: participant.Mobile }
                  let emailParticipant = { FirstName: participant.FirstName, LastName: participant.LastName, Email: participant.Email }

                  let splicedParticipants = JSON.parse(String(JSON.stringify(participants)).toLowerCase());
                  splicedParticipants.splice(index, 1)

                  let filter = splicedParticipants.filter((filterParticipant) => {

                    let mobileFilterParticipant = { firstname: filterParticipant.firstname, lastname: filterParticipant.lastname, mobile: filterParticipant.mobile }
                    let emailFilterParticipant = { firstname: filterParticipant.firstname, lastname: filterParticipant.lastname, email: filterParticipant.email }

                    if(String(JSON.stringify(mobileParticipant)).toLowerCase() === String(JSON.stringify(mobileFilterParticipant)).toLowerCase())
                    {
                      return true;
                    }
                    return String(JSON.stringify(emailParticipant)).toLowerCase() === String(JSON.stringify(emailFilterParticipant)).toLowerCase();
                  })


                  if(filter.length > 0)
                  {
                    this.isDuplicateParticipant = true;
                  }
              })
            }

            if(this.isDuplicateParticipant)
            {
              this.processing = false;
              return;
            }

            
            const individualTickets = this.tickets.filter(ticket => ticket.type === 'individual');
            if (individualTickets.length > 0) {
              let promiseReq = [];

              individualTickets.forEach(ticket => {
                this.dynamicForm[ticket.code].forEach(participant => {
                  const payload = {
                    FirstName: participant.firstName,
                    LastName: participant.lastName,
                    Mobile: participant.mobile,
                    Email: participant.email
                  }
                  promiseReq.push(this.checkDuplicateRegister(payload));
                });
              });

              const promiseRes = await Promise.all(promiseReq);
              const invalidData = promiseRes.find(res => res.alreadyRegistered);

              if (invalidData) {
                this.valid = false;
                this.setDuplicateParticipant(invalidData.firstName);
                this.setStatus('already-registered');
              } else {
                if(this.calcTotal <= 0)
                {
                  this.setParticipants(this.dynamicForm)
                  await this.handleFreeTicket();
                }else{
                  this.$emit('next-step', { step: 3, participants: this.dynamicForm });
                }
              }
              this.processing = false;
            } else {
               if(this.calcTotal <= 0)
                {
                  this.setParticipants(this.dynamicForm)
                  await this.handleFreeTicket();
                }else{
                  this.$emit('next-step', { step: 3, participants: this.dynamicForm });
                }
            }
          } else {
            this.processing = false;
            console.log('error submit!!');
            return false;
          }
        });
      }
    },

    async handleFreeTicket(){
        this.$emit('next-step', { step:6 });
    },
    ticketName: function (code) {
      const ticket = this.tickets.find(ticket => ticket.code === code);

      return ticket?.name;
    },
    groupTitle: function (code) {
      const ticketName = this.ticketName(code);

      return this.eventConfig['names-label-names'].replace('{ticketname}', ticketName);
    },
    onParticipantChange: function (code, key) {
      if (this.dynamicForm[code][key].informalName === '' && this.dynamicForm[code][key].firstName !== '') {
        this.dynamicForm[code][key].informalName = this.dynamicForm[code][key].firstName;
      }

      if (this.dynamicForm[code][key].dietaryRequirements.toLowerCase() !== 'other' && this.dynamicForm[code][key].dietaryOther !== '') {
        this.dynamicForm[code][key].dietaryOther = '';
      }

      if (this.dynamicForm[code][key].accessibilityRequirements.toLowerCase() !== 'other' && this.dynamicForm[code][key].accessibilityOther !== '') {
        this.dynamicForm[code][key].accessibilityOther = '';
      }
    },
    onSelectAmount() {
      this.amountError.show = false;
    },
    validateCustomAmount() {
      this.amountError = { show: false, message: "" };
      if (this.$isNum(this.dynamicForm.customDonation)) {
        const maxDonation = this.donationConfig?.['maximum-donation'] ?? 0;
        const minDonation = this.donationConfig?.['minimum-donation'] ?? 0;

        if (this.dynamicForm.customDonation > maxDonation) {
          this.amountError.message = this.donationConfig?.['validation-donation-form']?.['invalid-donation-too-high']
            ?? "Your donation is higher than the maximum allowed";
          this.amountError.show = true;
        } else if (this.dynamicForm.customDonation < minDonation) {
          this.amountError.message = "Your donation is lesser than the minimum allowed";
          this.amountError.show = true;
        }
      } else {
        this.amountError.message = "Must input a number";
        this.amountError.show = true;
      }
    },
    handleDonationDetailChecked: function(itemCode, index)
    {
      let individualTickets = this.tickets;
      let initData = {
            prefix: null,
            firstName: null,
            lastName: null,
            postNominals: null,
            informalName: "",
            companyTitle: null,
            companyName: null,
            email: null,
            mobile: null,
            Jwt: null,
            isDonationDetailUsed: false,
            dietaryRequirements: "",
            dietaryOther: null,
            accessibilityRequirements: "",
            accessibilityOther: null
      };

      let selectedParticipant = this.dynamicForm[itemCode][index];
      selectedParticipant.isDonationDetailUsed = !selectedParticipant.isDonationDetailUsed;

      individualTickets.forEach(({code}) => {
          this.dynamicForm[code].forEach((participant, pIndex) => {
            if((pIndex == index && !participant.isDonationDetailUsed) || (pIndex != index && participant.isDonationDetailUsed))
            {
                participant.prefix = null;
                participant.firstName = null;
                participant.lastName = null;
                participant.informalName = null;
                participant.companyTitle = null;
                participant.companyName = null;
                participant.email = null;
                participant.mobile = null;
                participant.dietaryRequirements = "";
                participant.accessibilityRequirements = "";
                participant.isDonationDetailUsed = false;
                participant.Jwt = null;
                participant.isNullprefix = false;
                participant.isNullfirstName = false;
                participant.isNulllastName = false;
                participant.isNullinformalName = false;
                participant.isNullemail = false;
                participant.isNullmobile = false;
                
            }

            if(pIndex == index && participant.isDonationDetailUsed)
            {
                let { first_name, last_name, mobile, prefix, email, informal_name, company_name, company_title, diet, diet_other, access, access_other, jwt } = this.donationDetail
                
                
                participant.prefix = prefix;
                participant.firstName = first_name;
                participant.lastName = last_name;
                participant.informalName = informal_name;
                participant.companyTitle = company_title;
                participant.companyName = company_name;
                participant.email = email;
                participant.mobile = mobile;

                participant.isNullprefix = participant.prefix && participant.prefix != '' ? true : false;
                participant.isNullfirstName = participant.firstName && participant.firstName != '' ? true : false;
                participant.isNulllastName = participant.lastName && participant.lastName != '' ? true : false;
                participant.isNullinformalName = participant.informalName && participant.informalName != '' ? true : false;
                participant.isNullemail = participant.email && participant.email != '' ? true : false;
                participant.isNullmobile = participant.mobile && participant.mobile != '' ? true : false;



                participant.Jwt = jwt;
                if(diet === "OTH") {
                  participant.dietaryRequirements = diet_other;
                } else {
                  participant.dietaryRequirements = diet;
                }
                if(access === "OTH") {
                  participant.accessibilityRequirements = access_other;
                } else {
                  participant.accessibilityRequirements = access;
                }
            }
          })
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@font-face { font-family:'Gotham Narrow Book'; src:url('../../assets/fonts/GothamNarrow-Book.woff2') format('woff2'),url('../../assets/fonts/GothamNarrow-Book.woff') format('woff'); font-weight:normal; font-style:normal; font-display:swap; }

>>>.custom-input {
  img {
    z-index: 2;
  }
  .el-input {
    .el-input__inner {
      padding-left: 30px;
      font-size: 20px!important;
    }
  }
}

.dollar-sign {
  position: absolute;
  top: 15px;
  left: 10px;

  width: 11px;
}

.label {
  font-size: 14px;
}

.event-form-wrap {
  .el-alert {
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .el-button-group {
    display: flex;
    margin: 16px 0;
  }

  .el-button {
    width: 100%;
  }

  >>>.el-radio-group {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;

    .el-radio__input {
      margin-top: 2px;
    }

    .el-radio__label {
      font-size: 20px;
      font-family: "Gotham Narrow Book", sans-serif;
    }
  }

  .el-radio.is-bordered + .el-radio.is-bordered,
  .el-radio.is-bordered {
    margin: 0;
    margin-bottom: 16px;
    width: calc(100% / 2 - 10px);
  }

  .el-radio--medium.is-bordered {
    height: 56px;
    padding: 10px 20px 10px 10px;

    display: flex;
    align-items: center;
  }

  >>>.el-radio.is-bordered.is-checked {
    background: rgba(4, 173, 238, 0.05);

    .el-radio__label {
      font-weight: bold;
      color: #00529b;
    }
  }
}
</style>
